<template>
  <div class="page-header page-home">
    <div class="text">
      <div class="title">
        申请使用通信服务涉实名登记及电信网络新型违法犯罪的防范提示及责任告知书
      </div>
      <div v-html="text">{{ text }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "unicomDeal3",
  data() {
    return {
      text: "",
    };
  },
  created() {
    this.text = `
    为加强通讯工具（包括但不限于手机卡、无线上网卡、物联网卡、固话号码、宽带账号等所有通信企业的通讯工具）的规范管理，避免个人或单位在通信企业申请的通讯工具被违法犯罪人员用于实施电信网络新型违法犯罪活动，特将申请使用通信服务涉实名制登记及电信网络新型违法犯罪的相关法律责任及防范提示告知如下：
    —、明知他人实施电信网络诈骗犯罪，仍以出售、出租、出借、转让等方式非法提供本人（本单位）通讯工具供他人使用的，依照《关于办理电信网络诈骗等刑事案件适用法律若干问题的意见》（法发（2016）32 号）第四条第三款之规定，以电信网络诈骗共同犯罪追究刑事责任。
    二、个人或者单位应当妥善保管本人名下所有通讯工具，严禁以出售、出租、出借、转让等方式非法提供本人（本单 位）通讯工具供他人使用。实施上述禁止行为且该通讯工具 被查实用于实施电信网络诈骗等犯罪活动的，依照《中华人 民共和国刑法》第二百八十七条之二规定，以帮助信息网络 犯罪活动罪追究刑事责任。
    三、根据《广东省防范打击电信网络诈骗不良信用通信用户惩戒办法》（粤公通〔2020〕114 号）第五条之规定, 可

    以对电信网络诈骗不良信用通信用户名下的所有手机号码、固话号码、无线上网卡和物联网卡等通信业务一律先行全部关停，被关停后未经公安机关许可不得恢复，5 年内不得为其办理通信产品新入网业务并将其个人或单位信息向社会公布。
    四、根据《广东省防范打击电信网络诈骗不良信用通信 用户惩戒办法》（粤公通〔2020〕114 号）第三条之规定， 联通公司有权对于疑似非本人实名登记的号码暂停服务，并 要求用户通过线上或线下方式进行身份信息核验，对核验不 通过的或在规定期限内不配合核验的，有权终止其通信业务。
    五、新开户（或办理其他业务）实名登记提供的有效证件及留存的资料（包括单位资料/ 代理人/ 经办人/ 使用人提供的有效身份证件及资料），联通公司将于业务办理之日起 30 天内进行人工复核，如资料出现虚假、不实等不符合国家电话用户实名登记制度要求的，联通公司有权对该电话号码执行关停，并要求机主携带有效证件原件+手机 SI M 卡到联通营业厅或手机营业厅 APP 重新办理真实身份认证，实名认证通过后方可进行复通。
    六、申请人如有遗失通信工具，应立即挂失并报停。如被不法分子利用而造成第三方损失的，申请人应承担相关法律责任。

    申请人确认“_______已领取本次办理的号码为________的电话卡，我已清楚并知晓上述告知内容及相应法律责任，<span style="font-weight: 800;">将依法申请、使用本人（本单位）通讯工具，绝不非法向他人出售、出租、出借或转让通讯工具。”</span>特别提示：本告知书一经签署，即视为已知悉并理解本告知书内容，承诺不参与电信网络违法犯罪行为。`;
  },
};
</script>

<style lang="scss" scoped>
.page-home {
  width: 100%;
  overflow-x: hidden;
  display: flex;
  flex-direction: column;

  .text {
    padding: 1rem;
    font-size: 1rem;
    line-height: 1.5rem;
    white-space: pre-wrap;
    .title {
      font-weight: 800;
      text-align: center;
      margin: 1rem auto;
    }
  }
}
</style>
